import React from 'react'

import { Icon, SH3, Stack, XStack, colors } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'

import { ICta } from '../utils/interface'

export const Cta = ({ onPress, cta }: ICta) => {
  return (
    <Pressable onPress={onPress} className="mb-4">
      <XStack className="py-4/2 border-grays-40 items-center justify-between rounded-lg border bg-white px-3">
        <XStack className="items-center">
          <SH3 className="text-grays-80">{cta}</SH3>
        </XStack>
        <Stack>
          <Icon color={colors.primary[200]} type="ArrowRight" />
        </Stack>
      </XStack>
    </Pressable>
  )
}
